module.exports = __webpack_public_path__ + "img/fainc.c918471a.png";